import { z } from 'zod/v4';

import { FormulaScriptErrorRuntype } from '../formula/formulaScriptErrorBackendTypes';

const OkResponseRuntype = <T extends z.ZodTypeAny>(dataRuntype: T) =>
    z.object({
        result: z.literal('Ok'),
        data: dataRuntype,
    });

const ScriptErrorRuntype = z.object({
    result: z.literal('ScriptError'),
    data: FormulaScriptErrorRuntype,
});

const UnknownIdentifierRuntype = z.object({
    result: z.literal('UnknownIdentifier'),
    data: z.string(),
});

export const CalculationResultNullValue = z.object({
    result: z.literal('NullValue'),
    data: z.string(),
});

const ErrorResponseRuntype = z.union([ScriptErrorRuntype, UnknownIdentifierRuntype, CalculationResultNullValue]);

export const CalculationResult = <T extends z.ZodTypeAny>(dataRuntype: T) =>
    ErrorResponseRuntype.or(OkResponseRuntype(dataRuntype));
